import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=49d4a826&scoped=true&"
var script = {}
import style0 from "./ChangeLog.vue?vue&type=style&index=0&id=49d4a826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4a826",
  null
  
)

export default component.exports